/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { v4 as uuidv4 } from 'uuid';
import {
  Popup
} from 'semantic-ui-react';
import withScrollbar from '../Extensions/WithScrollbar';
import api from '../../api';
import RenderProjectTree from '../Extensions/RenderProjectTree';

class LitigatorRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popupStatus: {
        treePopup: false,
      },
      activeTreeIndex: '',
      securityTreeData: [],
    };
    this.handleTreeOpen = this.handleTreeOpen.bind(this);
    this.closePopup = this.closePopup.bind(this);
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  handleTreeOpen(value, ids) {
    //const { t } = this.props;
    const obj = JSON.parse(`[${ids}]`);
    const objData = { uploaded_file_ids: obj };
    const popupStatus = {
      treePopup: true,
    };

    api
      .getProjectTree(objData)
      .then((response) => {
        const data = response.response;
        this.setState({
          securityTreeData: data,
          popupStatus,
          activeTreeIndex: value,
        });
      })
      .catch((err) => {
        console.log(err);
        /*
        this.setState({
          error: t('modal.error.error_load'),
        });
      */
      });
  }

  closePopup() {
    const popupStatus = {
      treePopup: false,
    };

    this.setState({
      popupStatus,
      activeTreeIndex: '',
    });
  }

  render() {
    const {
      rowData,
      t,
      state,
    } = this.props;

    const {
      popupStatus,
      activeTreeIndex,
      securityTreeData,
    } = this.state;

    return Object.keys(rowData.litigators).map((groupName) => {
      console.log(groupName);
      return (
        <table
          className="wide_card_table wide_card_item"
          key={uuidv4()}
        >
          <colgroup>
            <col style={{ width: '12.9%' }} />
            <col style={{ width: '12.9%' }} />
            <col style={{ width: '55.5%' }} />
            <col style={{ width: '18.6%' }} />
          </colgroup>
          <tbody>
            {
              rowData.litigators[groupName].map((array, k) => {
                return (
                  <tr className="" key={uuidv4()}>
                    {
                      k === 0 ? (
                        <td
                          className="border-none tac border-bottom"
                          style={{ paddingLeft: '7px' }}
                          rowSpan={rowData.litigators[groupName].length}
                        >
                          {array.component_name}
                        </td>
                      ) : null
                    }
                    <td className="tac border-bottom">
                      {array.component_version}
                    </td>
                    <td className="sum_td border-bottom">
                      <Popup
                        trigger={(
                          <div
                            className="hover_area"
                          >
                            <table className="sub_table">
                              <colgroup>
                                <col style={{ width: '33%' }} />
                                <col style={{ width: '33%' }} />
                                <col style={{ width: '33%' }} />
                              </colgroup>
                              <tbody>
                                <tr>
                                  <td className="tac">
                                    {array.project_count}
                                  </td>
                                  <td className="tac">
                                    {array.project_version_count}
                                  </td>
                                  <td className="tac">
                                    {array.uploaded_file_count}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        )}
                        on="click"
                        position="bottom left"
                        open={
                          popupStatus.treePopup && activeTreeIndex === `${array.component_version}_${k}`
                        }
                        onOpen={() => {
                          return this.handleTreeOpen(`${array.component_version}_${k}`, array.uploaded_file_ids,);
                        }}
                        onClose={this.closePopup}
                        wide="very"
                      >
                        <RenderProjectTree
                          treeData={securityTreeData}
                          translate={t}
                          tableType
                          state={state}
                        />
                      </Popup>
                    </td>
                    <td className="tac border-bottom">
                      {array.last_detected}
                    </td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>
      );
    });
  }
}

export default withScrollbar(LitigatorRow);
